import { Button } from 'primereact/button'
import { InputText } from 'primereact/inputtext'
import { Messages } from 'primereact/messages'
import React, { useRef, useState } from 'react'
import axiosClient from '../constants'
import '../styles/_ForgotPassword.css'
const ForgotPassword = () => {
    const [userId, setUserId] = useState('')
    const messages = useRef(null);
    const generateVerificationLink = () => {
        axiosClient.get(`/generate-reset-password-link/${userId}`)
            .then(res => {
                if (res && res.status === 200) {
                    messages.current.show({ severity: 'success', summary: null, detail: 'A verification link was sent to your email address' });
                } else {
                    messages.current.show({ severity: 'error', summary: null, detail: `Couldn't send a verification link, check your user id.` });
                }
            }).catch(err => {
                console.error(err);
            })
    }
    return (
        <>
            <div className="app-topbar">
                <img alt="Logo" src="assets/layout/images/l.png" className="topbar-logo" />
            </div>
            <div className="main-container">
                <div className="main-content">
                    <h2>Enter your user id to send verification link</h2>
                    <Messages ref={messages} />
                    <InputText value={userId} onChange={(e) => setUserId(e.target.value)} type="email" className="email-input" />
                    <Button label="Send verification link" onClick={generateVerificationLink} style={{
                        textTransform: 'uppercase'
                    }} />
                </div>
            </div>
        </>
    )
}
export default ForgotPassword;